import styled from 'styled-components';

import { heading } from '@constants/fonts';

export const DashHeader = styled.h2`
  font-family: ${heading};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 20px;
  text-transform: uppercase;
  margin: 20px 15px 5px 15px;
`;
